export default class FormMenu {
	constructor(container) {
		this.controls = [];
		this.container = container;
		container.querySelectorAll('.form_menu__tab_control').forEach(item => {
			let control;
			switch (container.classList.contains('form_menu--transport_types')) {
				case true:
					switch (item.value) {
						case 'truck':
							control = new TruckControl(item, this);
							break;
						default:
							control = new TransportModeControl(item, this);
					}
					break;
				default:
					control = new MenuControl(item, this);
			}
			this.controls.push(control);
		});
	}

	init() {
		this.controls.forEach(control => control.init());
	}

	activateControl(control) {
		if (this.activeControl && this.activeControl.isRadio) {
			this.activeControl.element.dispatchEvent(new CustomEvent('update_state'));
		}

		this.activeControl = control;
		control.element.dispatchEvent(new CustomEvent('update_state'));

		const
			containerScrollLeft = this.container.scrollLeft,
			containerWidth = this.container.offsetWidth,
			controlOffsetLeft = control.label.offsetLeft,
			controlOffsetRight = controlOffsetLeft + control.label.offsetWidth,
			containerHorizontalPadding = parseInt(
				window
					.getComputedStyle(this.container)
					.getPropertyValue('padding-left')
			),
			scrollOptions = { behavior: 'smooth' };

		if (controlOffsetLeft < containerScrollLeft) {
			scrollOptions.left = controlOffsetLeft - containerHorizontalPadding;
		} else if (controlOffsetRight > containerScrollLeft + containerWidth) {
			scrollOptions.left =
				controlOffsetRight - containerWidth + containerHorizontalPadding;
		}

		this.container.scrollTo(scrollOptions);
	}
}

class MenuControl {
	constructor(element, menu) {
		if (element.menu_control) return;

		this.element = element;
		this.label = element.parentNode;
		this.menu = menu;
		this.element.menu_control = this;
		this.bindedElement =
			document.querySelector(this.element.dataset.bindedSelector);

		this.requestForm = document.getElementById('transportation_request_form');

		this.element.addEventListener('click', this.activateMenuControl());
		this.element.addEventListener('init', this.activateMenuControl());

		if (!this.bindedElement) return;

		this.bindedElement.control = this.element;

		this.element.addEventListener('update_state', this.toggleFunction());
		this.element.addEventListener('update_state', this.saveBindedState());
		this.element.addEventListener('update_state', event => {
			this.subControls().forEach(control => {
				control
					.menu_control
					.element
					.dispatchEvent(new CustomEvent('update_state'));
			});
		});
	}

	init() {
		this.element.dispatchEvent(new CustomEvent('update_state'));
		if (this.element.matches(':checked')) {
			this.element.dispatchEvent(new CustomEvent('init'));
		}
	}

	get isRadio() {
		return this.element.type == 'radio';
	}

	toggleFunction() {
		return (event) => {
			this.bindedElement.classList.toggle('hidden', !this.element.checked);
		};
	}

	activateMenuControl() {
		return (event) => {
			const ptlInput =
				this.requestForm && this.requestForm.querySelector(
					".ptl_block input[name='transportation_request[ptl]']"
				);
			if (
				ptlInput &&
				this.element.menu_control.element.name == 'transportation_request[transport_mode][name]'
			) {
				if (this.element.value == 'ship') {
					document.getElementById('default_ptl_legend').style.display = 'none';
					document.getElementById('ship_ptl_legend').style.display = 'block';

					document.querySelectorAll('.default_ptl_value').forEach(item => {
						item.style.display = 'none';
					});

					document.querySelectorAll('.ship_ptl_value').forEach(item => {
						item.style.display = 'block';
					});
				} else {
					document.getElementById('default_ptl_legend').style.display = 'block';
					document.getElementById('ship_ptl_legend').style.display = 'none';
					document.querySelectorAll('.default_ptl_value').forEach(item => {
						item.style.display = 'block';
					});

					document.querySelectorAll('.ship_ptl_value').forEach(item => {
						item.style.display = 'none';
					});
				}
			}

			if (this.menu.activeControl == this && this.isRadio) return;

			this.menu.activateControl(this);
		};
	}

	subControls() {
		return (
			Array.from(this.bindedElement.querySelectorAll('.form_menu__tab_control'))
		);
	}

	inputElements() {
		return Array.from(
			this.bindedElement.querySelectorAll('input, select, textarea')
		);
	}

	saveBindedState() {
		return event => {
			this
				.inputElements()
				.filter(item => {
					return !this.subControls().flatMap(input => {
						return input.menu_control.inputElements();
					}).includes(item);
				})
				.forEach(control => {
					if (this.element.checked) {
						if (control.old_checked !== undefined) {
							control.checked = control.old_checked;
							control.old_checked = undefined;
						}
						if (control.old_required !== undefined) {
							control.required = control.old_required;
							control.old_required = undefined;
						}
						if (control.old_value !== undefined) {
							control.value = control.old_value;
							control.old_value = undefined;
						}

						control.removeAttribute('disabled');
					} else {
						if (control.old_value === undefined) {
							control.old_value = control.value;
							control.value = '';
						}
						if (control.old_checked === undefined) {
							control.old_checked = control.checked;
							control.checked = false;
						}
						if (control.old_required === undefined) {
							control.old_required = control.required;
							control.required = false;
						}

						control.setAttribute('disabled', 'disabled');
					}
				});
		};
	}
}

class TransportModeControl extends MenuControl {
	constructor(element, menu) {
		super(element, menu);
		if (this.element.form.id === "transportation_request_first_step_form") {
			this.element.addEventListener('click', this.updateHistory.bind(this));
			this.element.addEventListener('init', this.changeTransportMode.bind(this));
			this.element.addEventListener('click', this.changeTransportMode.bind(this));
		}
	}

	updateHistory() {
		if (history.state) {
			if (history.state.transport_type == this.element.value) return;
		}

		history.replaceState(
			{ transport_type: this.element.value },
			'',
			window.location.pathname.replace(
				new RegExp(
					`(?:(?:/(?:${this.stateReplacePattern()}))|(?:(/\\w+)?|/))$`
				),
				`$1/${this.element.value}`
			) + window.location.search
		);
	}

	changeTransportMode() {
		let searchParams = new URLSearchParams(window.location.search);

		if (searchParams.has('main_header')) return;

		document.querySelector('#main_title').textContent =
			this.element.dataset.mainTitle;

		const newPathname = this.element.value;

		document.querySelectorAll('.tile > a').forEach(element => {
			element.href =
				element.href.replace(/(transport_mode=)[^&]+/, '$1' + newPathname);
		});
	}

	stateReplacePattern() {
		return (
			Array
				.from(this.menu.controls)
				.map(control => control.element.value)
				.join('|')
		);
	}
}

class TruckControl extends TransportModeControl {
	constructor(element, menu) {
		super(element, menu);

		this.swiper_container = this.bindedElement.querySelector('.swiper');
	}

	toggleFunction() {
		return event => {
			this.bindedElement.classList.toggle(
				'hidden',
				!(
					this.element.checked &&
					(
						!this.bindedElement.classList.contains('directions-depended') ||
						this.element.form.form_object.direction_completed()
					)
				)
			);

			if (this.swiper_container) this.swiper_container.swiper.update();

			this.saveBindedState();
		};
	}
}
